import ImageUploader from "../../ImageUploader";
import * as styles from "../styles/styles";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Typography,
} from "@mui/material";
import InputField from "../../InputField";
import PhoneNumberInput from "../../PhoneNumberInput";
import AddressMapInput from "../../AddressMapInput";
import CustomDatePicker from "../../CustomDatePicker";
import CustomCheckboxLabel from "../../CustomCheckboxLabel";
import { useTranslation } from "react-i18next";

const ManageProfile = (props) => {
  const {
    formik,
    isloading,
    snackbar,
    imageUrl,
    setImageUrl,
    tempImageFile,
    setTempImageFile,
    initialImageUrl,
    setImageDeleted,
    setOpenDeleteAccountDialog,
    handleClose,
    actionLoader,
  } = props;

  const {
    checkboxContainer,
    formRow,
    divider,
    deleteAccount,
    profileSection,
    footer,
    button,
    primaryButton,
    contentContainer,
    contentContainerWrapper,
  } = styles;

  const { t } = useTranslation("profile-drawer", "validation-error-messages");

  return (
    <Box sx={contentContainerWrapper}>
      <Box sx={contentContainer}>
        <form id="profile-form" onSubmit={formik.handleSubmit}>
          <Box sx={profileSection}>
            <ImageUploader
              imageUrl={imageUrl}
              setImageUrl={setImageUrl}
              tempImageFile={tempImageFile}
              setTempImageFile={setTempImageFile}
              allowedTypes={[
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/webp",
                "image/gif",
              ]}
              isLoading={isloading}
              maxSizeMB={15}
              onError={(msg) => snackbar(msg, "error")}
              hint={t("imageUploadHint")}
              hintAlignmentBoxSx={{
                width: "auto",
              }}
              buttonAlignment="row"
              changeImgText={t("replacePhoto")}
              uploadImgText={t("uploadPhoto")}
              imageStyle={{
                borderRadius: "50%",
                width: "80px",
                height: "80px",
                objectFit: "cover",
              }}
              removeButtonSx={{
                top: "-8px",
              }}
              initialImageUrl={initialImageUrl}
              onImageDelete={() => setImageDeleted(true)}
              resetImageDeleted={() => setImageDeleted(false)}
            />
          </Box>

          <Divider sx={divider} />

          <Box sx={formRow}>
            <InputField
              name="firstName"
              label={t("firstName")}
              value={formik.values.firstName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder={t("firstName")}
              disabled={isloading}
              error={
                formik.touched.firstName && Boolean(formik.errors.firstName)
              }
              helperText={formik.touched.firstName && formik.errors.firstName}
            />

            <InputField
              name="lastName"
              label={t("lastName")}
              value={formik.values.lastName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder={t("lastName")}
              disabled={isloading}
              error={formik.touched.lastName && Boolean(formik.errors.lastName)}
              helperText={formik.touched.lastName && formik.errors.lastName}
            />
          </Box>

          <Box sx={formRow}>
            <InputField
              name="email"
              label={t("email")}
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              type="email"
              placeholder={t("email")}
              disabled
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />

            <PhoneNumberInput
              wrapperId="profile-phone-input"
              label={t("phoneNumber")}
              disabled={isloading}
              prefixName="phonePrefix"
              phoneNumberName="phoneNumber"
              prefixValue={formik.values.phonePrefix}
              phoneNumber={formik.values.phoneNumber}
              phoneNumberPlaceholder={t("phoneNumber")}
              setFieldValue={formik.setFieldValue}
              handleChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              touched={formik.touched}
              errors={formik.errors}
            />
          </Box>

          <Box sx={{ mb: "32px" }}>
            <AddressMapInput
              label={t("address")}
              placeholder={t("address")}
              mapIcon={true}
              disabled={isloading}
              value={
                typeof formik.values.address === "object"
                  ? formik.values.address?.address
                  : formik.values.address
              }
              onPlaceSelected={(placeDetails) =>
                formik.setFieldValue("address", placeDetails)
              }
              onBlur={() => formik.setFieldTouched("address", true)}
              error={formik.touched.address && Boolean(formik.errors.address)}
              helperText={formik.touched.address && formik.errors.address}
            />
          </Box>

          <Box sx={{ ...formRow, mb: 0 }}>
            <InputField
              name="postalCode"
              label={t("zipCode")}
              value={formik.values.postalCode}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder={t("zipCode")}
              type="number"
              disabled={isloading}
              error={
                formik.touched.postalCode && Boolean(formik.errors.postalCode)
              }
              helperText={formik.touched.postalCode && formik.errors.postalCode}
            />

            <CustomDatePicker
              name="birthday"
              label={t("birthday")}
              placeholder={t("birthday")}
              formik={formik}
              selected={
                formik.values.birthday ? new Date(formik.values.birthday) : null
              }
              dateFormat="dd/MM/yyyy"
              disabled={isloading}
              showYearDropdown
              error={formik.touched.birthday && Boolean(formik.errors.birthday)}
              helperText={formik.touched.birthday && formik.errors.birthday}
            />
          </Box>

          <Divider sx={divider} />

          <Box sx={checkboxContainer}>
            <CustomCheckboxLabel
              label={t("agreeMarketingMaterials")}
              checked={formik.values.agreeMarketingMaterials}
              disabled={isloading}
              onChange={(e) =>
                formik.setFieldValue(
                  "agreeMarketingMaterials",
                  e.target.checked
                )
              }
              formControlLabelTextStyle={{
                fontSize: "15px",
              }}
            />

            {/* <CustomCheckboxLabel
              label={t("agreeShareDetailsWithCM")}
              checked={formik.values.agreeShareDetailsWithCM}
              disabled={isloading}
              onChange={(e) =>
                formik.setFieldValue(
                  "agreeShareDetailsWithCM",
                  e.target.checked
                )
              }
              formControlLabelTextStyle={{
                fontSize: "15px",
              }}
            /> */}
          </Box>

          <Divider sx={divider} />

          <Typography
            onClick={() => {
              setOpenDeleteAccountDialog(true);
            }}
            sx={deleteAccount}
          >
            {t("deleteAccount")}
          </Typography>
        </form>
      </Box>

      <Box sx={footer}>
        <Button onClick={handleClose} sx={button}>
          {t("cancel")}
        </Button>
        <Button
          disabled={actionLoader}
          type="submit"
          form="profile-form"
          variant="contained"
          sx={primaryButton}
        >
          {t("saveChanges")}
          {actionLoader && (
            <CircularProgress
              size={20}
              color="rgba(255, 255, 255, 1)"
              sx={{ ml: "8px" }}
            />
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default ManageProfile;
